import { AuthStore } from './AuthStore';
import { MerchantContextStore } from './MerchantContextStore';
import { AgentRegistryStore } from './AgentRegistryStore';
import { ThemeStore } from './ThemeStore';
import { CommandPaletteStore } from './CommandPaletteStore';
import { SkillStore } from './SkillStore';
import { AgentDetailStore } from './AgentDetailStore';
import { KnowledgeStore } from './KnowledgeStore';
import { KnowledgeDetailStore } from './KnowledgeDetailStore';
import { RagStore } from './RagStore';
import { PrebuiltPromptStore } from './PrebuiltPromptStore';
import { SystemPromptStore } from './SystemPromptStore';
import { HelpStore } from './HelpStore';
import { NavStore } from './NavStore';
import { InsightsStore } from './InsightsStore';
import { ScenariosStore } from './ScenariosStore';
import { ModelPricingStore } from './ModelPricingStore';
import { ModelsStore } from './ModelsStore';
import { ValidationRunsStore } from './ValidationRunsStore';
import { ActivityStore } from './ActivityStore';
import { ProcessLibraryStore } from './ProcessLibraryStore';
import { SystemHealthStore } from './SystemHealthStore';
import { CostsStore } from './CostsStore';
import { StudioModuleStore } from './StudioModuleStore';

// Composes all top-level stores. Each store gets a back-reference to the root
// so cross-store reactions are wired explicitly (no global imports of stores).

export class RootStore {
  themeStore: ThemeStore;
  commandPaletteStore: CommandPaletteStore;
  authStore: AuthStore;
  merchantContextStore: MerchantContextStore;
  agentRegistryStore: AgentRegistryStore;
  skillStore: SkillStore;
  agentDetailStore: AgentDetailStore;
  knowledgeStore: KnowledgeStore;
  knowledgeDetailStore: KnowledgeDetailStore;
  ragStore: RagStore;
  prebuiltPromptStore: PrebuiltPromptStore;
  systemPromptStore: SystemPromptStore;
  helpStore: HelpStore;
  navStore: NavStore;
  insightsStore: InsightsStore;
  scenariosStore: ScenariosStore;
  modelPricingStore: ModelPricingStore;
  modelsStore: ModelsStore;
  validationRunsStore: ValidationRunsStore;
  activityStore: ActivityStore;
  processLibraryStore: ProcessLibraryStore;
  systemHealthStore: SystemHealthStore;
  costsStore: CostsStore;
  studioModuleStore: StudioModuleStore;

  constructor() {
    // ThemeStore first so the rest of the app can read mode without hooks ordering issues.
    this.themeStore = new ThemeStore(this);
    this.commandPaletteStore = new CommandPaletteStore(this);
    this.authStore = new AuthStore(this);
    this.merchantContextStore = new MerchantContextStore(this);
    this.agentRegistryStore = new AgentRegistryStore(this);
    this.skillStore = new SkillStore(this);
    this.agentDetailStore = new AgentDetailStore(this);
    this.knowledgeStore = new KnowledgeStore(this);
    this.knowledgeDetailStore = new KnowledgeDetailStore(this);
    this.ragStore = new RagStore(this);
    this.prebuiltPromptStore = new PrebuiltPromptStore(this);
    this.systemPromptStore = new SystemPromptStore(this);
    this.helpStore = new HelpStore(this);
    this.navStore = new NavStore(this);
    this.insightsStore = new InsightsStore(this);
    this.scenariosStore = new ScenariosStore(this);
    this.modelPricingStore = new ModelPricingStore(this);
    this.modelsStore = new ModelsStore(this);
    this.validationRunsStore = new ValidationRunsStore(this);
    this.activityStore = new ActivityStore(this);
    this.processLibraryStore = new ProcessLibraryStore(this);
    this.systemHealthStore = new SystemHealthStore(this);
    this.costsStore = new CostsStore(this);
    this.studioModuleStore = new StudioModuleStore(this);
  }
}
